import { coerce, object } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import {
  IS_INTEGER,
  IS_POSITIVE,
  IS_REQUIRED,
  IS_VALID,
} from '@occc-app/lib/constants/validationMessages';
import { AwardCountWithoutTransactionSchema } from '@occc-app/routes/Offer/schemas/award-count.schema';
import { CustomDataSchema, OfferNameAndDescriptionSchema } from '@occc/validation';
import { fulfillmentWindowZodSchema } from '@occc/feat-constraints';

import { StoredValueConfigureFormValues } from './stored-value-configure-form.types';

const requiredPositiveInteger = coerce
  .number({
    required_error: IS_REQUIRED,
    invalid_type_error: IS_VALID,
  })
  .int({ message: IS_INTEGER })
  .min(1, { message: IS_POSITIVE });

const storedValueDiscountSchema = object({
  pointsPerConversion: requiredPositiveInteger,
  moneyPerConversion: requiredPositiveInteger,
  minPointsPerConversion: requiredPositiveInteger,
  maxPointsPerConversion: requiredPositiveInteger,
  expirationDays: requiredPositiveInteger,
});

const configurationSchema = OfferNameAndDescriptionSchema.extend({
  storedValueDiscount: storedValueDiscountSchema,
  awardCount: AwardCountWithoutTransactionSchema,
  fulfillmentWindow: fulfillmentWindowZodSchema,
  customData: CustomDataSchema,
});

const validateConfiguration = makeValidate(configurationSchema);
export const validateStoredValueConfiguration = (values: StoredValueConfigureFormValues) =>
  validateConfiguration({
    ...values,
    storedValueDiscount: values.storedValueDiscount ?? {},
  });
